import { generatePath } from 'react-router-dom';

import {
  NBA_SCOUTING_CENTER_SCORES,
  NBA_SCOUTING_CENTER_SCORES_GAMEID,
  NBA_SCOUTING_CENTER_STATS,
} from '@sorare/core/src/constants/__generated__/routes';
import { useFeatureFlags } from '@sorare/core/src/hooks/useFeatureFlags';
import { navLabels } from '@sorare/core/src/lib/glossary';

enum ScoutingCenterTabs {
  SCORES = 'SCORES',
  STATS = 'STATS',
}
const tabs = [
  {
    tab: ScoutingCenterTabs.STATS,
    label: navLabels.stats,
    to: generatePath(NBA_SCOUTING_CENTER_STATS),
    matches: [NBA_SCOUTING_CENTER_STATS],
  },
  {
    tab: ScoutingCenterTabs.SCORES,
    label: navLabels.scores,
    to: generatePath(NBA_SCOUTING_CENTER_SCORES),
    matches: [NBA_SCOUTING_CENTER_SCORES, NBA_SCOUTING_CENTER_SCORES_GAMEID],
  },
];

export const useRandomizeNbaScoutingTabs = () => {
  const {
    flags: { useRandomizeNbaScoutingTabs: flag = false },
  } = useFeatureFlags();
  const randomizedTabs = flag ? [...tabs] : [...tabs].reverse();
  return randomizedTabs;
};
